export default __webpack_public_path__ + "static/slide-1-e0ea55742b307238542ce84533efd289.png";